import { EventEmitter } from "events";
import dispatcher from "../dispatcher";
import { swipeMachineConstant } from "../constants/constants";


class SwipeMachineStore extends EventEmitter {
    constructor() {
        super();
        this.swipes = [];
    }

    getAll() {
        return this.swipes;
    }

    handleAction(action) {
        switch (action.type) {
            case swipeMachineConstant.SWIPEMACHINE_CREATED: {
                this.swipes.push(action.swipe);
                this.emit(swipeMachineConstant.SWIPEMACHINE_CREATED, action.msg);
                this.emit(swipeMachineConstant.SWIPEMACHINEE_STORE_CHANGE);
                break;
            }
            case swipeMachineConstant.SWIPEMACHINE_CREATION_FAILED: {
                this.emit(swipeMachineConstant.SWIPEMACHINE_CREATION_FAILED, action.msg);
                break;
            }
            case swipeMachineConstant.FETCHED_ALL_SWIPEMACHINE: {
                this.swipes = action.data;
                this.emit(swipeMachineConstant.SWIPEMACHINEE_STORE_CHANGE);
                break;
            }
            default:
                break;

        }
    }
}

const swipeMachineStore = new SwipeMachineStore();
dispatcher.register(swipeMachineStore.handleAction.bind(swipeMachineStore));

export default swipeMachineStore;


// WEBPACK FOOTER //
// ./src/jsx/store/swipe-machine-store.jsx